import { format } from 'date-fns';
import { toastr } from 'react-redux-toastr';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ResponseProps } from '../../../utils/helper';
import {
  getListaAuditoriaFailure,
  getListaAuditoriaRequest,
  getListaAuditoriaSuccess,
} from './actions';
import { ListaAuditoriaTypes } from './types';

function* listaAuditoria({
  payload,
}: ReturnType<typeof getListaAuditoriaRequest>) {
  const {
    pageNo,
    pageSize,
    identificationKey,
    ownershipType,
    dtInicio,
    dtFim,
    company,
  } = payload.AuditoriaSetings;

  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/logs?pageNo=${pageNo}&pageSize=${pageSize}&identificationKey=${identificationKey}&ownershipType=${ownershipType}${
        dtInicio ? '&dtInicio=' + dtInicio : ''
      }${dtFim ? '&dtFim=' + dtFim : ''}`,
      {
        headers: {
          company: company,
        },
      },
    );

    interface Data {
      log_id: number;
      policy_process_ds: string;
      document_id: string;
      log_dt: number;
      total_itens: number;
    }

    interface DataTable {
      IDEvento: string;
      DescricaoEvento: string;
      Detalhe: string;
      data: string;
      total_itens: number;
    }

    const data: DataTable[] = response.data.map((item: Data) => {
      return {
        IDEvento: item.log_id,
        DescricaoEvento: item.policy_process_ds,
        Detalhe: item.document_id,
        data: format(item.log_dt, 'dd/MM/yyyy hh:mm'),
        total_itens: item.total_itens,
      };
    });

    yield put(getListaAuditoriaSuccess(data));
  } catch (error) {
    const message = error.response.data.message;

    if (message?.includes('Titular inexistente')) {
      const toastrConfirmOptions = {
        onOk: () => {},
        onCancel: () => {},
        okText: 'Ok',
        disableCancel: true,
      };

      toastr.confirm(
        'CPF inválido ou inexistente na base para a categoria selecionada.',
        toastrConfirmOptions,
      );
    }

    if (message?.includes('Não existem dados para o filtro selecionado.')) {
      const toastrConfirmOptions = {
        onOk: () => {},
        onCancel: () => {},
        okText: 'Ok',
        disableCancel: true,
      };

      toastr.confirm(
        'Não existem dados para o filtro selecionado.',
        toastrConfirmOptions,
      );
    }

    yield put(getListaAuditoriaFailure());
  }
}

export default all([
  takeLatest(ListaAuditoriaTypes.GET_LISTA_AUDITORIA_RESQUEST, listaAuditoria),
]);
